import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import AppKitProvider from './providers/AppKitProvider';
import './index.css';
import { router } from './lib/router';
import { ToastContainer } from 'react-toastify';
import { Bounce } from 'react-toastify';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <AppKitProvider>
        <ThemeProvider>
          <RouterProvider router={router} />
          <ToastContainer
            position='top-right'
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='light'
            transition={Bounce}
          />
        </ThemeProvider>
      </AppKitProvider>
    </AuthProvider>
  </StrictMode>,
);
